import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import { selectUpdatePhoneNumModalShow, setPhoneNumberUpdateModalShow, setUpdateFlag, updateUserPhoneNumAsync } from "../features/authentication/authenticationSlice"
import { Box, Button, FormControl, Modal, TextField } from "@mui/material"
import { loginModalStyle } from "../app/consts"

const UpdatePhoneNumberModal = (props: any) => {
  const dispatch = useAppDispatch()
  const updatePhoneNumberModalShow = useAppSelector(selectUpdatePhoneNumModalShow)

  const [PhoneNumberHelper, setPhoneNumberHelper] = useState('')
  const [PhoneNumberValid, setPhoneNumberValid] = useState<boolean>(true)
  const [PhoneNum, setPhoneNum] = useState('');

  const validatePhoneNumber = (phoneNum: string) => {
    if (phoneNum === "") {
      setPhoneNumberHelper("נא להזין מספר טלפון")
      setPhoneNumberValid(false)
      return
    }
    const reg = new RegExp("^05\\d{8}$");
    const isValid = reg.test(phoneNum);
    if (isValid === false) {
      setPhoneNumberValid(false)
      setPhoneNumberHelper("מספר הטלפון חייב להתחיל ב-05 ולהכיל בדיוק 10 ספרות")
    }
    else {
      setPhoneNumberValid(true)
      setPhoneNumberHelper("")
    }
    setPhoneNum(phoneNum)
  }

  const handlePhoneNumberChange = (data: { username: string, phone_num: string }) => {
    dispatch(updateUserPhoneNumAsync(data)).unwrap().then(() => {
      dispatch(setUpdateFlag());
    }).catch(() => { });
    dispatch(setPhoneNumberUpdateModalShow(false))
  }

  return (
    <Modal
      open={updatePhoneNumberModalShow}
      onClose={() => dispatch(setPhoneNumberUpdateModalShow(false))}>
      <Box sx={{...loginModalStyle,minHeight:'20dvh'}}>
        <form method='POST' id='updatePhoneNum' style={{ textAlign: 'center', fontSize: '30px' }} onSubmit={(e) => e.preventDefault()}>
          <FormControl>
            <TextField variant="filled" label='מספר טלפון נייד' type='tel' onChange={(e) => validatePhoneNumber(e.target.value)} error={!PhoneNumberValid} helperText={PhoneNumberHelper} required style={{ textAlign: 'center', width: '300px', }} /><br />
            <Button id='submit' type='submit' onClick={() => handlePhoneNumberChange({ "username": props.user.username, "phone_num": PhoneNum })}>שמור</Button>
          </FormControl>
        </form>
      </Box>
    </Modal>
  )
}

export default UpdatePhoneNumberModal